module.exports = __webpack_public_path__ + "assets/pencil-edit.59455981.svg";